import { ClientWithAuth } from 'client/services/service';
import { bookmarkTypes } from 'client/utils/constants/appStates';
import { portalBaseUrl } from 'client/utils/constants/frontEndConfig';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';
const serviceUrlSuffix = '/profile-service';

export default {
    getUserProfile: async () => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/me`);
        return response.data;
    },
    getOrganisations: async () => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/me/organisations`);
        return response?.data;
    },
    getTsAndCs: async () => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/termsandconditions`);
        return response?.data;
    },
    patchPreference: async (locale) => {
        const body = {
            lang: locale.split('-').shift()
        };
        const response = await ClientWithAuth.patch(`${serviceUrlSuffix}/me/preference`, body);
        return response?.data;
    },
    patchAcceptTsAndCs: async (tsAndCsModifiedDate, locale) => {
        const body = {
            acceptedTerms: {
                lang: locale.split('-').shift(),
                dateModifiedForTermsAccepted: tsAndCsModifiedDate
            }
        };
        const response = await ClientWithAuth.patch(`${serviceUrlSuffix}/me`, body);
        return response?.data;
    },
    patchAcceptUserReaffirmation: async (reaffirmationId) => {
        const response = await ClientWithAuth.patch(`${serviceUrlSuffix}/reaffirmation/${reaffirmationId}`, '');
        return response?.data;
    },
    postBookmark: async (name, mapExtent, geometry, bufferRadiusMetres) => {
        const body = JSON.stringify({
            name,
            mapExtent,
            geometry,
            type: geometry ? bookmarkTypes?.REQUEST : bookmarkTypes?.LOCATION,
            ...(Number.isFinite(bufferRadiusMetres) && { buffer: bufferRadiusMetres })
        });
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.post(`${serviceUrlSuffix}/${epsgCode}/bookmark`, body);
        return {
            ...response.data,
            bookmarkUrl: `${portalBaseUrl}/map?bookmark=${response?.data?.bookmarkId}`
        };
    },
    getBookmark: async (bookmarkId) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/bookmark/${bookmarkId}`);
        return response?.data;
    },
    getBookmarks: async (params) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/me/bookmark`, { params });
        return response?.data;
    },
    deleteBookmarks: async (bookmarkIds) => {
        const response = await ClientWithAuth.delete(`${serviceUrlSuffix}/bookmark`, { data: bookmarkIds });
        return response?.data;
    },
    getFeedbackActivityTypes: async () => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/feedback/activityTypes`);
        return response.data;
    },
    postFeedback: async (additionalComments, activityComments, activityType, easeOfUseScore, feedbackType, ratingScore, recommendationScore) => {
        const body = JSON.stringify({
            additionalComments,
            activityFeedback: [
                {
                    activityType: activityType,
                    activityComments: activityComments
                }
            ],
            easeOfUseScore,
            feedbackType,
            ratingScore,
            recommendationScore
        });
        const response = await ClientWithAuth.post(`${serviceUrlSuffix}/feedback`, body);
        return response?.data;
    },
    postUserFeedbackLog: async (feedbackType, wasDismissed) => {
        const body = JSON.stringify({
            feedbackType,
            wasDismissed
        });
        const response = await ClientWithAuth.post(`${serviceUrlSuffix}/userfeedbacklog`, body);
        return response?.data;
    },
    getUserFeedbackLog: async () => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/userfeedbacklog/feedbacktype/general/latest`);
        return response?.data;
    },
    patchLastLogindate: async () => {
        const response = await ClientWithAuth.patch(`${serviceUrlSuffix}/me/lastlogindate`);
        return response.data;
    }
};
